<div class="maintenance-alert-wrapper p-3">
  <p class="maintenance-description">
    {{ "maintenance-alert.description" | translate }}
  </p>

  <form [formGroup]="configForm">
    <div class="row" formArrayName="days">
      <div class="col-6">
        <div class="maintenance-day" *ngFor="let i of firstHalfIndexes">
          <label class="m-0">{{ "clients.home.feeding.day" | translate }} {{ i + 1 }}</label>
          <input
            type="number"
            class="form-control"
            [formControlName]="i"
            [class.is-invalid]="
              daysArray.at(i).invalid &&
              daysArray.at(i).touched
            "
          />
        </div>
      </div>
      <div class="col-6">
        <div class="maintenance-day" *ngFor="let i of secondHalfIndexes">
          <label class="m-0">{{ "clients.home.feeding.day" | translate }} {{ i + 1 }}</label>
          <input
            type="number"
            class="form-control"
            [formControlName]="i"
            [class.is-invalid]="
              daysArray.at(i).invalid &&
              daysArray.at(i).touched
            "
          />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-3">
      <button
        (click)="setConfig()"
        type="button"
        [disabled]="configForm.invalid || loading_petition"
        class="btn btn-success px-4 maintenance-save-btn"
      >
        <app-spinner [smallLoader]="true" [spinnerColor]="'text-white'" *ngIf="loading_petition">
        </app-spinner>
        <span class="m-0" *ngIf="!loading_petition"> {{ "fuzzy-logic-config.save-changes" | translate }} </span>
      </button>
    </div>
  </form>
</div>
